export default "__VITE_ASSET__e2c7606b__"